import router from '../../router';
export const toLink = (name, query = {}) => {
    let path= name=='/'?'/':'/'+name
    router.push({ path: path, query: query }).catch(err => {console.log(err)});
};
